import "./styles.scss";

import type { JSX } from "react";

export default function PictureFrame(): JSX.Element {
  return <div className="picture-frame" data-testid="picture-frame"></div>;
}
